<template>
    <div class="lo root">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .lo.root {
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-family: $base-font-style;
        color: $deep;
        line-height: 1.7;
    }
</style>
